import { render, staticRenderFns } from "./TemplateFontFiles.vue?vue&type=template&id=c70ba9d2"
import script from "./TemplateFontFiles.vue?vue&type=script&lang=js"
export * from "./TemplateFontFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports